const LEGO_DOMAINS = ["lego.com", "LEGO.com"];

export const isLegoEmail = (email) => {
  const checkEmail = email.toLowerCase();
  return LEGO_DOMAINS.includes(checkEmail?.split("@").at(-1));
};
